<template>
  <div>
    <span class="dr-radiobuttons-header">{{ caption }}</span>
    <v-radio-group v-model="value" >
      <v-radio
        v-for="(element, index) in radioButtonItems"
        :key="index"
        :label="`${element.text}`"
        :value="element.value"
        @change="invokeActionOnClick(model.GenerationOnChange, { value: element.value })"
        :disabled="isDisabled"
        ></v-radio>
    </v-radio-group>   
  </div>
</template>

<script>
import inputWidgetsWrapperMixin from '../../mixins/input-widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'
import baseMixin from '../../mixins/base-mixin'
import actionMixin from '../../mixins/actions-mixin'

export default {
  name: 'dr-radiobuttons-component',
  mixins: [inputMixin, baseMixin, actionMixin, inputWidgetsWrapperMixin],
  computed: {
    radioButtonItems() {
      if (this.isInEditorMode) {
        return ['Radio 1', 'Radio 2']
      }
      const radioButtonItemsVal = this.getDataSourceField(this.model.Items)
      if (!radioButtonItemsVal) {
        return []
      }
      // converting all values to an object
      return radioButtonItemsVal.map(el => {
        if (typeof el === 'object') {
          return el
        } 
        return {text: el, value: el}
      })
    },
    value: {
      get() {
        return this.getDataSourceField(this.model.Value)
      },
      set(val) {
        this.setDataSourceField(this.model.Value, val)
      }
    },
    caption() {
      return this.evaluateExpression(this.model.Caption)
    }
  }
}
</script>

<style>
.dr-radiobuttons-header {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  padding-right: 5px;
  user-select: none;
}
</style>
